let overlay = document.getElementById("overlay");
let popup = document.getElementById("popup");
let popupParagraph = document.getElementById("popupParagraph");
let closePopup = document.getElementById("closePopup");

const objectData = [
  {
    id: 1,
    name: "info",
    onClick: () => {
      overlay.style.display = "block";
      popup.style.display = "block";
      popupParagraph.innerHTML = `
        <div class="images">
          <img src="../images/logo.png" class="dblogo">
          <img src="../images/three.png" class="threelogo">
        </div>
        <p class="text">
          <br />
          <b>First person controller</b>
          <br /><br />
          Prototype of 3d application developed in Three.js with movement and interaction in 3d scene.
          Keyboard + mouse control, touch control, object interaction and collision detection. 
          Starting point of 3d web app development.
          <br /><br />
          <b>Mobile</b>:
          <br ><br >
          For the mobile version, rendering optimizations were made by scaling down the city model and disabling antialiasing, ensuring better performance on less powerful devices.
          <br /><br />
          <b>Future update</b>:
          <br ><br >
          Compatibility with Gamepad/Controller, new interaction, ester egs, jump and physics.
          <br /><br />
          <b>City model</b>:
          <br /><br />
          <a href="https://sketchfab.com/3d-models/low-poly-city-41697300a4c643d089784b8688b2ed2c" target="_blank">
            https://sketchfab.com/3d-models/low-poly-city-41697300a4c643d089784b8688b2ed2c
          </a>
        </p>
      <br />`;
      setTimeout(() => {
        popup.classList.add("show");
      }, 10);
    },
  },
  {
    id: 2,
    name: "dblogoContainer",
    onClick: () => {
      overlay.style.display = "block";
      popup.style.display = "block";
      popupParagraph.innerHTML = `
        <div class="images">
          <img src="../images/logo.png" class="dblogo">
          <img src="../images/three.png" class="threelogo">
        </div>
        <p class="text">
          <br />
          <b>Visit my site</b>
        
          <br /><br />
          <a href=" https://www.davidebalice.dev" target="_blank">
            https://www.davidebalice.dev
          </a>
        </p>
      
      `;
      setTimeout(() => {
        popup.classList.add("show");
      }, 10);
    },
  },
  {
    id: 3,
    name: "ufoContainer",
    onClick: () => {
      overlay.style.display = "block";
      popup.style.display = "block";
      popupParagraph.innerHTML = `Message for you:<br /><br />⧫≋⧽ 𖤹𐌴𐍁𐍅⧹ ᒷ𖤸𖥞𐍄𐌙𖦊 ◄⥍𖠂𐌸𖤰⧽ 𐍅𐌴𖥝𐌄⧽𖢣! ⧼≋⧽
      𖥠ᒷ𖦄𐌙𖤸𐍇𐍄 ⧺𖥠𐍀⧹⍯𖦍𖤹𐍅𐌴⧼ 𖥞𐌴𐌴𖠂⥍𐍀𐌄⧼ ⥜⧽𖤹𐌴𖥝ᒷ𐌄𖤹𖠂𐍇
      𖥠𖠂⧽𖤸𖠂⥍𐍄⥜⧼𐌄⧼𖤹𐍀𖥝𐌴𐍀𖥞𖥞𐌴⧽! ◄⧼𐌄𖤹𐍀𐍅𖠂⧹𖠂𖠂𐌄𐍇≋𖤹𐌴𐍁𐍅⧹ ᒷ𖤸𖥞𐍄𐌙𖦊 ◄⥍𖠂𐌸𖤰⧽ 𐍅𐌴𖥝𐌄⧽𖢣! ⧼≋⧽
      𖥠ᒷ𖦄𐌙𖤸𐍇𐍄 ⧺𖥠𐍀⧹⍯𖦍𖤹𐍅𐌴⧼ 𖥞𐌴𐌴𖠂⥍𐍀𐌄⧼ ⥜⧽𖤹𐌴𖥝ᒷ𐌄𖤹𖠂𐍇`;
      setTimeout(() => {
        popup.classList.add("show");
      }, 10);
    },
  },
  {
    id: 4,
    name: "carContainer",
    onClick: () => {
      overlay.style.display = "block";
      popup.style.display = "block";
      popupParagraph.innerHTML = `
      
      <div class="images">
          <img src="../images/logo.png" class="dblogo">
          <img src="../images/three.png" class="threelogo">
        </div>
        <p class="text text-center">
          <br />
          <b>This is a car!</b>
          <br /><br /><br /><br />
        </p>
      </div>
      
      `;
      setTimeout(() => {
        popup.classList.add("show");
      }, 10);
    },
  },
  {
    id: 5,
    name: "balloonContainer",
    onClick: () => {
      overlay.style.display = "block";
      popup.style.display = "block";
      popupParagraph.innerHTML = `
      
        <div class="images">
          <img src="../images/logo.png" class="dblogo">
          <img src="../images/three.png" class="threelogo">
        </div>
        <p class="text text-center">
          <br />
          <b>This is a balloon!</b>
          <br /><br /><br /><br />
        </p>
      </div>
      
      
      `;
      setTimeout(() => {
        popup.classList.add("show");
      }, 10);
    },
  },
  {
    id: 6,
    name: "heliContainer",
    onClick: () => {
      overlay.style.display = "block";
      popup.style.display = "block";
      popupParagraph.innerHTML = `
      
        <div class="images">
          <img src="../images/logo.png" class="dblogo">
          <img src="../images/three.png" class="threelogo">
        </div>
        <p class="text text-center">
          <br />
          <b>This is an helicopter!</b>
          <br /><br /><br /><br />
        </p>
      </div>
      
      
      `;
      setTimeout(() => {
        popup.classList.add("show");
      }, 10);
    },
  },
];

export default objectData;

closePopup.addEventListener("click", () => {
  popup.classList.remove("show");
  setTimeout(() => {
    overlay.style.display = "none";
    popup.style.display = "none";
  }, 500);
});
